/**
 * LlamadasTurno — GEN-MO-017: las llamadas a modelo de un turno (paso, regla de política, modelo,
 * tokens y coste). Solo se monta para el Owner (admin) al abrir «Coste»; la puerta real es
 * GET /v1/admin/turnos/{message_id}/llamadas (403 al resto). El kernel decide la regla y el coste;
 * aquí solo se pintan. Fila sin regla = anterior a GEN-MO-017: no se reconstruye.
 */

import { useEffect, useState } from 'react'
import { getLlamadasTurno } from '../api/client.js'

const ETIQUETA_REGLA = {
  juez: 'Política · juez',
  resumen: 'Política · resumen',
  juez_confirmacion: 'Política · confirmación del juez',
  agente_defecto: 'Política · agente por defecto',
  clase_tarea: 'Política · clase de tarea',
  ficha: 'Ficha del agente',
  override_conversacion: 'Elegido en la conversación',
  optimizador: 'Optimizador',
  default_secreto: 'Modelo por defecto',
  subagente: 'Subagente (modelo del SDK)',
}
const ORIGEN = { dktec: '(DKtec)', personalizada: '(personalizada)' }
export const SIN_REGISTRO = 'sin registro (anterior a GEN-MO-017)'

export function etiquetaRegla(regla, origen, clase) {
  if (!regla) return { texto: SIN_REGISTRO, clave: null }
  const base = ETIQUETA_REGLA[regla] ?? regla
  const sufijo = ORIGEN[origen] ? ` ${ORIGEN[origen]}` : ''
  // GEN-MO-011: la clase de tarea que reconoció el kernel en el mensaje (si la hay)
  const porClase = clase ? ` · clase ${clase}` : ''
  return { texto: `${base}${sufijo}${porClase}`, clave: regla }
}

export const eur = v => `${Number(v).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} €`
export const tokens = l => (l.input_tokens + l.output_tokens + l.cache_creation_input_tokens + l.cache_read_input_tokens)
  .toLocaleString('es-ES')

export default function LlamadasTurno({ messageId, fecha }) {
  const [datos, setDatos] = useState(null)

  useEffect(() => {
    let vivo = true
    getLlamadasTurno(messageId, { fecha })
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se han podido cargar las llamadas del turno.' }))
    return () => { vivo = false }
  }, [messageId, fecha])

  if (!datos) return <p className="coste-nota">Cargando llamadas…</p>
  if (datos.error) return <p className="coste-nota" role="alert">{datos.error}</p>
  if (!datos.llamadas.length) return <p className="coste-nota">Este turno no tiene llamadas registradas.</p>

  return (
    <table className="mec-tabla llamadas-turno" aria-label="Llamadas del turno">
      <thead>
        <tr><th>Paso</th><th>Regla</th><th>Modelo</th><th className="coste-eur">Tokens</th><th className="coste-eur">Coste</th></tr>
      </thead>
      <tbody>
        {datos.llamadas.map((l, i) => {
          const regla = etiquetaRegla(l.regla, l.clasificacion_origen, l.clase)
          return (
            <tr key={`${l.paso}|${l.modelo}|${i}`}>
              <td>{l.paso || 'sin desglose'}</td>
              <td title={regla.clave ?? undefined}>{regla.texto}</td>
              <td>{l.modelo || '—'}</td>
              <td className="coste-eur">{tokens(l)}</td>
              <td className="coste-eur">{eur(l.eur)} {l.estimado && <span className="coste-marca">estimado</span>}</td>
            </tr>
          )
        })}
        <tr className="coste-total">
          <td colSpan={4}>Total del turno</td>
          <td className="coste-eur">{eur(datos.total_eur)}</td>
        </tr>
      </tbody>
    </table>
  )
}
